import React from 'react';
import {observer} from 'mobx-react'
import Image from './Image'
import BaseBindedComponent, { BaseBindedComponentProps, BaseBindedComponentState } from '../base-components/BaseBindedComponent'
import { IUIDomainImageDef } from '../../datatypes';
import { DomainAttrInUIComponentProps } from './BaseUIComponent';

interface DomainImageProps extends BaseBindedComponentProps{
    /** @override */
    metadata:IUIDomainImageDef;

    /** @override */
    domainAttribute:DomainAttrInUIComponentProps;    
}

interface DomainImageState extends BaseBindedComponentState{
    
}


class DomainImage extends BaseBindedComponent<DomainImageProps, DomainImageState> {
  render() {
    let url = this.getBindedValue() as string;
    return (
      <React.Fragment>
      {url && <Image
        {...this.props}
        src={url}/>}
      </React.Fragment>
    )
  }
}

export default observer(DomainImage);